import { Modal as AntModal } from 'antd';
import { GrFormClose } from 'react-icons/gr';

import styles from './modal.module.scss';

const Modal = ({
	open,
	title,
	onCancel,
	onOk,
	footer,
	width,
	children,
	destroyOnClose,
	bodyStyle,
	modalStyle,
	closable,
}) => {
	return (
		<div className={styles['wrapper']}>
			<AntModal
				open={open}
				title={title ? title : ''}
				onCancel={onCancel}
				onOk={onOk}
				centered={true}
				closeIcon={<GrFormClose className={styles['close-icon']} />}
				closable={closable}
				footer={footer ? footer : null}
				keyboard={true}
				maskClosable={false}
				width={width}
				rootClassName={styles['modal-wrapper']}
				destroyOnClose={destroyOnClose}
				styles={bodyStyle}
				style={modalStyle}
			>
				<div className={styles['content']}>{children}</div>
			</AntModal>
		</div>
	);
};

export default Modal;
